import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import SearchIcon from '@material-ui/icons/Search';

import { toggleShowDialog } from '../../store/actions/dialog';
import { getCampanhas } from '../../store/actions/publicidade';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';

const CampanhasPublicitarias = props => {
    const history = useHistory();
    const { campanhas, toggleShowDialog, getCampanhas, loading } = props
    // Estado que controla a visibilidade do loading

    useEffect(_ => {
        getCampanhas();
    }, [])

    const handleDetalharCampanha = (id) => {
        history.push({
            pathname: '/campanhas-publicitarias-no-app/visualizar-campanha',
            state: {
                campanhaId: id,
                from: window.location.pathname,
            },
        });
    }

    const columns = [
        {
            name: 'Prévia',
            selector: (row) => (
                row.imagemBanner
                    ?
                    <a href={row.imagemBanner} target='_blank'><img src={row.imagemBanner} style={{ height: '80px', marginTop: '10px', marginBottom: '10px' }} /></a>
                    :
                    'Sem imagem'
            ),
            width: '225px',
        },
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '80px',
            sortable: true,
        },
        {
            name: 'Título/Nome',
            selector: (row) => row.titulo,
            sortable: true,
        },
        {
            name: <>Início<br /> Campanha</>,
            selector: (row) => row.dataInicioVeiculacao,
            sortable: true,
            width: '150px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: <>Término<br />Campanha</>,
            selector: (row) => row.dataFimVeiculacao,
            sortable: true,
            width: '150px',
            headerStyle: { whiteSpace: 'normal' },
        },
        {
            name: 'Ativo',
            center: 'true',
            selector: (row) => (
                row.ativo
                    ?
                    <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon>
                    :
                    <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '90px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Campanha' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarCampanha(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>
                    <Tooltip title='Detalhar' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="excluir" size='small' color='secondary' onClick={() => handleDetalharCampanha(row.id)}><SearchIcon /></IconButton>
                    </Tooltip>
                </>
            ),
            width: '100px',
        }
    ];

    const handleEditarCampanha = (id) => {
        history.push({
            pathname: '/campanhas-publicitarias-no-app/editar-campanha',
            state: {
                campanhaId: id,
                from: window.location.pathname,
            },
        });
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Campanhas Publicitárias' subtitulo={new Date().toLocaleString('pt-BR')} />

            <DataTableComponent
                columns={columns}
                data={campanhas}
                visibleSearch={campanhas && campanhas.length > 0}

            />
            <Grid container >
                <Button component={Link} variant='contained' color='secondary' to={{ pathname: '/campanhas-publicitarias-no-app/cadastrar-campanha', state: { from: window.location.pathname } }}>Cadastrar Campanha</Button>
            </Grid>
        </>
    )
}

const mapStateToProps = state => (
    {
        campanhas: state.publicidade.campanhas,
        idDialogShow: state.dialog.idDialogShow
    }
)

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        toggleShowDialog,
        getCampanhas,
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(CampanhasPublicitarias)